import React from "react";
import { Row, Col } from "react-bootstrap";
import CardHeader from "../../../components/CardHeader";
import AggregateCounts from "./AggregateCounts";
import Demo from "./Demo";

export default function Misc({
  metrics,
  race,
  ethnicity,
  update_date,
}: Data.Misc) {
  return (
    <Col className="m-tabs m-presumptive card">
      <CardHeader
        title="Multisystem inflammatory syndrome in children (MIS-C)"
        subTitle={`Last updated at ${update_date}`}
        toolTipText="Multisystem inflammatory syndrome in children (MIS-C) is a rare but serious complication that some children develop after getting a COVID-19 infection.  Different body parts can be affected, such as the heart, lungs, kidneys, brain, skin, eyes, or digestive organs.  Tracking how many children have MIS-C helps public health officials and health care providers learn more about MIS-C illness and risk factors, how to diagnose it, and ways to distinguish it from other illnesses."
      />
      <Row className="h-100">
        <Col md={12} lg={6} className="d-flex">
          <AggregateCounts {...metrics} />
        </Col>
        <Col md={12} lg={6}>
          <div className="mt-3">
            <Demo race={race} ethnicity={ethnicity} />
          </div>
        </Col>
      </Row>
    </Col>
  );
}
